export const ensureUniqueName = (name: string, existingNames: string[]) => {
    const baseName = name.split(" ").join("_");
    const uniqueName = existingNames.includes(baseName)
        ? `${baseName}_${existingNames.length + 1}`
        : baseName;
    return uniqueName;
};

export const formatPrice = (price: number) => {
    return price.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
    });
};
